import { User } from '../Model/Implementation/User';

export default function equalsUser(userA?: User,
                                   userB?: User)
{
    return userA !== undefined
        && userB !== undefined
        && userA.id === userB.id;
}